
import React from 'react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import AnimateInView from '@/components/ui/animate-in-view';

const FenceCTA = () => {
  return (
    <section className="section bg-forti-fi-charcoal text-white" aria-labelledby="fence-cta-heading">
      <div className="container mx-auto text-center max-w-3xl">
        <AnimateInView animation="fade-in">
          <h2 id="fence-cta-heading" className="mb-6 text-white">
            Toughen Your Existing Fences
          </h2>
          <p className="mb-8 text-forti-fi-lavender text-xl">
            Transform your perimeter from passive to proactive with our patented on-fence technology.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Button asChild size="lg" className="bg-forti-fi-teal hover:bg-forti-fi-teal/90 text-white">
              <Link to="/contact">
                Get a Free Demo
              </Link>
            </Button>
            <Button asChild size="lg" variant="outline" className="border-forti-fi-lavender text-forti-fi-lavender hover:bg-white/5">
              <Link to="/solutions">
                View All Solutions
              </Link>
            </Button>
          </div>
        </AnimateInView>
      </div>
    </section>
  );
};

export default FenceCTA;
